import React, { useState, useEffect, useCallback, memo, useRef } from "react";
import Navbar from "../navbar/Navbar";
import "./Home.css";
import Collections from "./collections/Collections";
import Features from "./Feature/Features";
import Shapingd from "./shaping/ Shapingd";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";
import ExploreCollection from "./exploreCollection/ExploreCollection";
import { Icon } from "@iconify/react";

// Dummy initial data
const DUMMY_DATA = [];
const IMAGES1 = [
	"https://demo.riskydress.com/images/2026/ENCHANTED-B/B40351%20%283%29.png",
	"https://demo.riskydress.com/images/2026/ENCHANTED-E/E40233%20%281%29.png",
	"https://demo.riskydress.com/images/2026/MONSINI/50020%20%281%29.png",
];

const IMAGES2 = [
	"https://demo.riskydress.com/images/2026/ENCHANTED-B/B40350%20%281%29.png",
	"https://demo.riskydress.com/images/2026/ENCHANTED-E/E40238%20%282%29.png",
	"https://demo.riskydress.com/images/2026/MONSINI/50015%20%281%29.png",
];

const IMAGES3 = [
	"https://demo.riskydress.com/images/2026/ENCHANTED-B/B40358%20%282%29.png",
	"https://demo.riskydress.com/images/2026/ENCHANTED-E/E40225%20%282%29.png",
	"https://demo.riskydress.com/images/2026/MONSINI/50010%20%280%29.png",
];

const TEXTS1 = ["Enchanted Bridal ", "Enchanted Evening ", "Monsini Prom "];
const LINKS = ["/bridal/", "/evening/", "/prom/"];

// Memoized Image Component
const MemoizedImage = memo(({ src, alt, className }) => (
	<img src={src} alt={alt} className={className} loading="lazy" />
));

// Memoized Text Component
const MemoizedTextOverlay = memo(
	({ currentImageIndex, fade, text1, latestYear }) => (
		<div
			className={`overlay-inside font-Jost-Regular ${
				fade ? "opacity-100" : "opacity-0"
			}`}>
			<Link to={LINKS[currentImageIndex]?.toLowerCase() + latestYear || ""}>
				<div className={`text-container font-lora tron ${fade && "troff"}`}>
					<h2>{text1[currentImageIndex]}</h2>
					<h2>{latestYear} Collection</h2>
					<button>Explore More</button>
				</div>
			</Link>
		</div>
	)
);

const Home = () => {
	const [data, setData] = useState(DUMMY_DATA);
	const [years, setYears] = useState([]);
	const [categories, setCategories] = useState([]);
	const [currentImageIndex, setCurrentImageIndex] = useState(0);
	const [fade, setFade] = useState(true);
	const [nextSlideReady, setNextSlideReady] = useState(false);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);
	const loadedSlidesRef = useRef(new Set([0]));

	useEffect(() => {
		const fetchProducts = async () => {
			setLoading(true);
			setError(null);

			try {
				const response = await fetch(
					`https://admin.monsinidress.com/api/products/brand`,
					{
						method: "POST",
						headers: { "Content-Type": "application/json" },
						body: JSON.stringify({ brand: "Monsini" }),
					}
				);

				if (!response.ok) {
					throw new Error(`Failed to fetch products: ${response.status}`);
				}

				const productsData = await response.json();

				console.log(productsData);
				// Use API data if available, otherwise fall back to dummy data
				if (
					productsData.data &&
					productsData.data.products &&
					productsData.data.products?.length > 0
				) {
					console.log("product data sadfsdf sadf", productsData.data.products);
					setData(productsData.data.products);
					setYears(productsData.data.years || []);
					setCategories(productsData.data.categories || []);
				} else {
					// If API returns unexpected structure, use dummy data but log warning
					console.warn("API returned unexpected structure, using dummy data");
					setYears([2026, 2025]);
					setCategories(["Bridal 2026", "Prom 2025", "Evening 2025"]);
				}
			} catch (error) {
				console.error("Error fetching products:", error);
				setError(error.message);
				// Fallback to dummy data on error
				setYears([2026, 2025]);
				setCategories(["Bridal 2026", "Prom 2025", "Evening 2025"]);
			} finally {
				setLoading(false);
			}
		};

		fetchProducts();
	}, []);

	console.log("Data fetched for Home:", data);

	// Get next slide index
	const getNextSlideIndex = useCallback((currentIndex) => {
		return currentIndex === IMAGES1.length - 1 ? 0 : currentIndex + 1;
	}, []);

	// Check if all three images for a slide are loaded
	const checkSlideLoaded = useCallback(async (slideIndex) => {
		return new Promise((resolve) => {
			let loadedCount = 0;
			const totalImages = 3;

			const checkImageLoaded = (src, callback) => {
				const img = new Image();
				img.onload = () => {
					loadedCount++;
					callback();
				};
				img.onerror = () => {
					loadedCount++;
					callback();
				};
				img.src = src;
			};

			// Check all three images for this slide
			checkImageLoaded(IMAGES1[slideIndex], () => {
				if (loadedCount === totalImages) resolve(true);
			});

			checkImageLoaded(IMAGES2[slideIndex], () => {
				if (loadedCount === totalImages) resolve(true);
			});

			checkImageLoaded(IMAGES3[slideIndex], () => {
				if (loadedCount === totalImages) resolve(true);
			});
		});
	}, []);

	// Preload next slide
	const preloadNextSlide = useCallback(
		async (nextIndex) => {
			if (loadedSlidesRef.current.has(nextIndex)) {
				setNextSlideReady(true);
				return;
			}

			console.log(`Preloading slide ${nextIndex}...`);
			const isLoaded = await checkSlideLoaded(nextIndex);

			if (isLoaded) {
				console.log(`Slide ${nextIndex} fully loaded!`);
				loadedSlidesRef.current.add(nextIndex);
				setNextSlideReady(true);
			}
		},
		[checkSlideLoaded]
	);

	// Handle slide transition
	const transitionToNextSlide = useCallback(() => {
		if (!nextSlideReady) {
			console.log("Next slide not ready yet, skipping transition");
			return;
		}

		setFade(false);
		setTimeout(() => {
			const nextIndex = getNextSlideIndex(currentImageIndex);
			setCurrentImageIndex(nextIndex);
			setFade(true);
			setNextSlideReady(false);

			// Preload the slide after next
			const nextNextIndex = getNextSlideIndex(nextIndex);
			if (!loadedSlidesRef.current.has(nextNextIndex)) {
				preloadNextSlide(nextNextIndex);
			}
		}, 300);
	}, [currentImageIndex, nextSlideReady, getNextSlideIndex, preloadNextSlide]);

	// Initial setup and preloading
	useEffect(() => {
		// Preload next slide immediately
		const nextIndex = getNextSlideIndex(currentImageIndex);
		preloadNextSlide(nextIndex);
	}, [currentImageIndex, getNextSlideIndex, preloadNextSlide]);

	// Auto-advance slideshow
	useEffect(() => {
		const interval = setInterval(transitionToNextSlide, 5000);
		return () => clearInterval(interval);
	}, [transitionToNextSlide]);

	// Safe latestYear calculation
	const latestYear = years && years.length > 0 ? Math.max(...years) : 2026;

	console.log("Latest Year:", latestYear);

	return (
		<div className="relative overflow-hidden">
			<Navbar />

			{loading && (
				<div className="flex flex-col justify-center items-center min-h-screen bg-gray-50">
					{/* Spinning Icon */}
					<Icon
						icon="svg-spinners:ring-resize"
						className="w-16 h-16 text-pink-500 animate-spin-slow"
					/>

					{/* Loading Text */}
					<div className="text-xl font-semibold text-gray-700 mt-4 font-poppins">
						Loading Monsini Collection...
					</div>

					{/* Optional: Simple Subtext for a better user experience */}
					<p className="text-sm text-gray-500 mt-1">
						Fetching the latest styles.
					</p>
				</div>
			)}

			{error && (
				<div className="bg-yellow-100 border border-yellow-400 text-yellow-700 px-4 py-3 rounded relative m-4">
					<strong className="font-bold">Warning: </strong>
					<span className="block sm:inline">{error}. Using demo data.</span>
				</div>
			)}

			<div className="image-container mt-24">
				<div className="text-overlay">
					<MemoizedTextOverlay
						currentImageIndex={currentImageIndex}
						fade={fade}
						text1={TEXTS1}
						latestYear={latestYear}
					/>
				</div>
				<div className="image-set im1">
					<MemoizedImage
						src={IMAGES1[currentImageIndex]}
						alt="Slideshow"
						className={`image ${fade ? "fade-in" : "fade-out"}`}
					/>
				</div>
				<div className="image-set m2">
					<MemoizedImage
						src={IMAGES2[currentImageIndex]}
						alt="Slideshow"
						className={`image ${fade ? "fade-in" : "fade-out"}`}
					/>
				</div>
				<div className="image-set m3">
					<MemoizedImage
						src={IMAGES3[currentImageIndex]}
						alt="Slideshow"
						className={`image ${fade ? "fade-in" : "fade-out"}`}
					/>
				</div>
			</div>

			<ExploreCollection years={latestYear} />
			<Collections data={data} years={years} categories={categories} />
			<Features data={data} />
			<Shapingd />
			<Footer />
		</div>
	);
};

export default memo(Home);
